Vue.use(VeeValidate, { locale: 'ja' }); // good to go.
var vm = new Vue({
  el: '#login',
  data: {
    loginning: false,
    isError: false,
    isExist: true,
    notices: [],
    notice: {},
    email: '',
    password: '',
    errorMsg: null,
    isChangedError: false,
    supportDesk: '',
    label: '',
    logo: '/static/front/public/img/logo_login.png',
    alternative: 'Eagle Eye',
    crShown: true,
  },
  created: function() {
    localStorage.clear();
    this.getNotices();
    this.getSupportDesks();
    this.label = this.getUrlParam('f') === 'l' ? 'パスワード再発行' : 'パスワード登録'
    if (window.location.hostname.includes('eagleeye-a-plus') ) {
      this.logo = '/static/front/public/img/logo_login_aplus.png';
      this.alternative = 'Eagle Eye A+',
      this.crShown = false;
    }
  },
  filters: {
    formatDate: function(time) {
      var date = new Date(time);
      if (date === undefined) {
        return '';
      }
      return moment(date).format('YYYY-MM-DD');
    }
  },
  watch: {
    password: {
      handler: function (password) {
        this.$validator.extend('eepassword', {
          getMessage: function () {
            return 'パスワードを正しく入力してください'
          },
          validate: function(value) {
            const r = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[\!@#\$%\^&\*\(\)_\+~`\|\}\{\[\]\\\:;\?><\,\./\-=]).{8,30}$/
            return r.test(value)
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getUrlParam: function(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
      return null;
    },
    validateLogin: function() {
      vm.loginning = true;
      vm.$validator.validateAll().then(function(result){
        if (result) {
          vm.doLogin();
          return;
        }
        vm.loginning = false;
      });
    },
    validateSendMail: function() {
      vm.$validator.validateAll().then(function(result){
        if (result) {
          vm.doSendMail();
          return;
        }
      });
    },
    validateChangePassword: function() {
      vm.$validator.validateAll().then(function(result){
        if (result) {
          vm.doChangePassword();
          return;
        }
      });
    },
    getNotices: function() {
      let url = '/front/api/notice/public';
      if (window.location.hostname.includes('eagleeye-a-plus')) {
        url = '/front/api/notice/aplus_public'
      }
      axios
        .get(url)
        .then(function(response) {
          if (response.data.status == 0) {
            vm.notices = response.data.data;
          }
        })
        .catch(function(error) {
          Sentry.captureException(error);
        });
    },
    getCookie: function(name) {
      var value = '; ' + document.cookie;
      var parts = value.split('; ' + name + '=');
      if (parts.length === 2)
        return parts
          .pop()
          .split(';')
          .shift();
    },
    doLogin: function() {
      axios
        .post(
          '/front/postsign',
          {
            email: this.email,
            password: this.password
          },
          { headers: { 'X-CSRFToken': this.getCookie('csrftoken') } }
        )
        .then(function(response) {
          if (response.data.status == 0) {
             window.localStorage.setItem("id_token", response.data.data.id_token);
             window.localStorage.setItem("industry_cd", response.data.data.industry_cd);
             window.localStorage.setItem("uid", response.data.data.uid);
             window.localStorage.setItem("product_attribute_use", response.data.data.product_attribute_use);
             window.localStorage.setItem("td_product_attribute_use", response.data.data.td_product_attribute_use);
             window.localStorage.setItem("days_remaining", response.data.data.days_remaining);
             return (window.location.href = '/');
          } else if (response.data.status == 1) {
            vm.loginning = false;
            vm.errorMsg = response.data.message;
            return;
          } else {
            window.localStorage.setItem("id_token", response.data.data.id_token);
            window.localStorage.setItem("uid", response.data.data.uid);
            window.localStorage.setItem("product_attribute_use", response.data.data.product_attribute_use);
            window.localStorage.setItem("td_product_attribute_use", response.data.data.td_product_attribute_use);
            window.localStorage.setItem("days_remaining", response.data.data.days_remaining);
            return (window.location.href = '/front/shop_select');
          }
        })
        .catch(function(error) {
          Sentry.captureException(error);
          vm.loginning = false;
          vm.isError = true;
        });
    },
    doSendMail: function() {
      axios
        .post(
          '/front/api/user/mail/reset',
          {
            email: this.email
          },
          { headers: { 'X-CSRFToken': this.getCookie('csrftoken') } }
        )
        .then(function(response) {
          vm.isError = response.data.isError;
          if (!vm.isExist) {
            return;
          }
          if (!vm.isError) {
            return (window.location.href = '/front/password/send?f=' + vm.getUrlParam('f'));
          } else if (response.data.needSelect) {
            return (window.location.href = '/front/shop_select');
          }
        })
        .catch(function(error) {
          Sentry.captureException(error);
          vm.isError = true;
        });
    },
    doChangePassword: function() {
      axios
        .post(
          '/front/api/user/password/loginchange',
          {
            password: this.password,
            v: vm.getUrlParam('v')
          },
          { headers: { 'X-CSRFToken': this.getCookie('csrftoken') } }
        )
        .then(function(response) {
          if (response.data.status == 2) {
            vm.isChangedError = true;
          } else if (response.data.status == 0) {
            return (window.location.href = '/front/password/loginchanged');
          }
        })
        .catch(function(error) {
          Sentry.captureException(error);
          vm.isChangedError = true;
        });
    },
    dateFormat: function(row, column) {
      var date = row[column.property];
      if (date === undefined) {
        return '';
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
    goBack: function() {
      window.location.href = '/';
    },
    getSupportDesks: function() {
      const _this = this
      axios
        .get('/front/api/common/support_desk')
        .then(function(response) {
          if (response.data.status == 0) {
            let key = 'support_desk_before_login';
            let mailAddress = 'eagleeye-d@truedata.co.jp'
            if (window.location.hostname.includes('eagleeye-a-plus')) {
              key = 'aplus_support_desk_before_login'
              mailAddress = 'eagleeye-a-plus@truedata.co.jp'
            }
            const settings = _.filter(response.data.data, setting => {
              return setting.key === key
            })
            if (settings.length === 1) {
              _this.supportDesk = settings[0].value.replace(/{mailAddress}/g, mailAddress)
            } else {
              _this.supportDesk = ''
            }
          }
        })
        .catch(function(error) {
          Sentry.captureException(error);
        });
    },
    getLabel: function() {
      // ログイン画面にある「パスワードをお忘れの方はこちら」を押下して遷移した時: true
      return vm.getUrlParam('f') === 'l' ? 'パスワード再発行' : 'パスワード登録'
    },
  }
});
